import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { CustomerPersonaPopup } from './CustomerPersonaPopup';

export const CUSTOMER_PERSONA_POPUP = Symbol('CUSTOMER_PERSONA');

export const useCustomerPersonaPopup = ({ isBackButtonShown = false } = {}) => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(CUSTOMER_PERSONA_POPUP, CustomerPersonaPopup);
  });

  return useCallback(
    ({
      customerPersona = null,
      onUpdatedCallback = null,
      brandVoice,
      language,
      isEditor,
      onSave,
    }) => {
      popups.openPopup(CUSTOMER_PERSONA_POPUP, {
        customerPersona,
        isBackButtonShown,
        language,
        onUpdatedCallback,
        brandVoice,
        isEditor,
        onSave,
        onCancel: () => {
          popups.closePopup(CUSTOMER_PERSONA_POPUP);
        },
      });
    },
    [popups, isBackButtonShown]
  );
};
